/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TemperatureIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Temperature',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 20.368V10h-4v10.368a6 6 0 1 0 4 0Z" />
    <path
      d="M18 1.8A4.2 4.2 0 0 1 22.2 6v12.941l.715.54A8.126 8.126 0 0 1 26.2 26a8.2 8.2 0 1 1-16.4 0 8.126 8.126 0 0 1 3.285-6.519l.715-.54V6A4.2 4.2 0 0 1 18 1.8ZM18 0a6 6 0 0 0-6 6v12.045a10 10 0 1 0 12 0V6a6 6 0 0 0-6-6Z"
    />
  </svg>`;
};
